import { useState, useRef, useEffect } from "react";
import Tooltip from "@mui/material/Tooltip";
import { cn } from "@/utils/css";

export const TruncatedText = ({ children, className, as: Component = "span" }) => {
    const textRef = useRef(null);
    const [isTruncated, setIsTruncated] = useState(false);

    useEffect(() => {
        const element = textRef.current;
        if (element) {
            setIsTruncated(element.scrollWidth > element.clientWidth);
        }
    }, [children]);

    const content = (
        <Component
            ref={textRef}
            className={cn("block truncate", className)}
        >
            {children}
        </Component>
    );

    if (isTruncated) {
        return (
            <Tooltip title={children} arrow>
                {content}
            </Tooltip>
        );
    }

    return content;
};
